export class TrainUsers {
    Id: number =0;
    TrainId: number =0;
    UserId: number =0;
    IsAdmin: number =0;
    CreatedAt: Date;
    UpdatedAt: Date;
    AspNetUsersId: string ="";
    AccessFlag:boolean =true;
}